var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/** Calculates Clusters based on dbscan algorithm in wasm.
 * @param embedX - embeddings x location.
 * @param embedY - embeddings y location.
 * @param minPts - minimum number of points in a cluster.
 * @param epsilon - epsilon.
 * @returns array with cluster indexes.
 */
export function getDbscanWorker(embedX, embedY, epsilon, minPts) {
    return __awaiter(this, void 0, void 0, function* () {
        return new Promise(function (resolve, reject) {
            const worker = new Worker(new URL('./clustering-worker', import.meta.url));
            worker.postMessage({ embedX, embedY, minPts, epsilon });
            worker.onmessage = ({ data: { error, clusters } }) => {
                worker.terminate();
                error ? reject(error) : resolve(clusters);
            };
        });
    });
}
//# sourceMappingURL=dbscan-worker-creator.js.map